import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import { useRunOnce } from '@leanpay/hooks'
import { initPdfDownloadHandler } from '@leanpay/services'

import AppInit from './app-init'

import MainLayout from './main-layout'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchIntervalInBackground: true,
        },
    },
})

const App = () => {
    useRunOnce(() => {
        initPdfDownloadHandler()
    })

    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <AppInit>
                    <MainLayout />
                </AppInit>
            </BrowserRouter>
        </QueryClientProvider>
    )
}

export default App
